import universal from 'react-universal-component';
import { inspirationPageRoutes } from '@client/pages/inspirationPage/inspirationRoutes';
import Loader from '@client/components/loader/Loader';
import ErrorLoadingRouteChunk from '@client/containers/errorLoadingRouteChunk/ErrorLoadingRouteChunk';
import { getMainRoutes } from '@client/shared/utils/routerUtils/routerUtils';
import { withRestrictions } from '@client/helperComponents/restrict/withRestrictions';
import { campaignsRoutes } from '@client/pages/campaignsPage/campaignsRoutes';
import { campaignPageRoutes } from '@client/pages/campaignPage/campaignPageRoutes';

const options = {
  error: ErrorLoadingRouteChunk,
  loading: Loader,
  ignoreBabelRename: true,
};

const MAIN_ROUTES = getMainRoutes();

export default [
  {
    path: MAIN_ROUTES.HOME.TO,
    exact: true,
    componentPath: 'pages/landingPage/startPage/StartPage',
    Component: universal(
      import('pages/landingPage/startPage/StartPage'),
      options
    ),
  },
  {
    path: MAIN_ROUTES.ADMIN.TO,
    exact: true,
    componentPath: 'pages/dashboardPage/DashboardPage',
    Component: withRestrictions({
      shouldBeLoggedIn: true,
    })(
      universal(import('pages/dashboardPage/DashboardPage'), options),
      universal(import('pages/loginPage/LoginPage'), options)
    ),
  },
  {
    path: MAIN_ROUTES.TERMS.TO,
    exact: true,
    componentPath: 'pages/termsPage/TermsPage',
    Component: universal(import('pages/termsPage/TermsPage'), options),
  },
  {
    path: MAIN_ROUTES.VERIFY_EMAIL.TO,
    exact: true,
    componentPath: 'pages/verifyEmailPage/VerifyEmailPage',
    Component: universal(
      import('pages/verifyEmailPage/VerifyEmailPage'),
      options
    ),
  },
  {
    path: MAIN_ROUTES.SYNC_EMAIL.TO,
    exact: true,
    componentPath: 'pages/syncEmailPage/SyncEmailPage',
    Component: universal(import('pages/syncEmailPage/SyncEmailPage'), options),
  },
  {
    path: MAIN_ROUTES.VERIFY_INVOICE_EMAIL.TO,
    exact: true,
    componentPath: 'pages/verifyInvoiceEmailPage/VerifyInvoiceEmailPage',
    Component: universal(
      import('pages/verifyInvoiceEmailPage/VerifyInvoiceEmailPage'),
      options
    ),
  },
  {
    path: MAIN_ROUTES.FINNISH_TERMS.TO,
    exact: true,
    componentPath: 'pages/termsPage/TermsPage',
    Component: universal(import('pages/termsPage/TermsPage'), options),
  },
  {
    path: MAIN_ROUTES.FRILANS_FINANS.TO,
    exact: true,
    componentPath: 'pages/frilansFinansPage/FrilansFinansPage',
    Component: universal(
      import('pages/frilansFinansPage/FrilansFinansPage'),
      options
    ),
  },
  {
    path: MAIN_ROUTES.FRILANS_FINANS.TO,
    exact: true,
    componentPath: 'pages/frilansFinansPage/FrilansFinansPage',
    Component: universal(
      import('pages/frilansFinansPage/FrilansFinansPage'),
      options
    ),
  },
  {
    path: `${MAIN_ROUTES.LOGIN.TO}`,
    exact: true,
    componentPath: 'pages/loginPage/LoginPage',
    Component: universal(import('pages/loginPage/LoginPage'), options),
  },
  {
    path: '/password-reset',
    exact: true,
    componentPath: 'pages/passwordResetPage/PasswordResetPage',
    Component: universal(
      import('pages/passwordResetPage/PasswordResetPage'),
      options
    ),
  },
  {
    path: '/advertiser/password-reset',
    exact: true,
    componentPath: 'pages/advertiserPasswordSetPage/AdvertiserPasswordSetPage',
    Component: universal(
      import('pages/advertiserPasswordSetPage/AdvertiserPasswordSetPage'),
      options
    ),
  },
  {
    path: `${MAIN_ROUTES.ADVERTISER_LOGIN.TO}`,
    exact: true,
    componentPath: 'pages/advertiserLoginPage/LoginPage',
    Component: universal(
      import('pages/advertiserLoginPage/LoginPage'),
      options
    ),
  },
  {
    path: `${MAIN_ROUTES.ADVERTISER_DASHBOARD.TO}`,
    exact: true,
    componentPath: 'pages/advertiserDashboardPage/AdvertiserDashboardPage',
    Component: withRestrictions({
      shouldBeLoggedIn: true,
      isAdvertiserRoute: true,
    })(
      universal(
        import('pages/advertiserDashboardPage/AdvertiserDashboardPage'),
        options
      ),
      universal(import('pages/advertiserLoginPage/LoginPage'), options)
    ),
  },
  {
    path: '/advertiser/campaign/:campaignId/:section',
    exact: true,
    componentPath: 'pages/advertiserCampaignPage/AdvertiserCampaignPage',
    Component: withRestrictions({
      shouldBeLoggedIn: true,
      isAdvertiserRoute: true,
    })(
      universal(
        import('pages/advertiserCampaignPage/AdvertiserCampaignPage'),
        options
      ),
      universal(import('pages/advertiserLoginPage/LoginPage'), options)
    ),
  },
  {
    path: `${MAIN_ROUTES.DASHBOARD.TO}`,
    exact: true,
    componentPath: 'pages/dashboardPage/DashboardPage',
    Component: withRestrictions({
      shouldBeLoggedIn: true,
    })(
      universal(import('pages/dashboardPage/DashboardPage'), options),
      universal(import('pages/loginPage/LoginPage'), options)
    ),
  },
  campaignsRoutes,
  campaignPageRoutes,
  inspirationPageRoutes,
  {
    path: `${MAIN_ROUTES.REPORT.TO}/:campaignId/:reportType`,
    componentPath: 'pages/reportViewPage/ReportViewPage',
    Component: withRestrictions({
      shouldBeLoggedIn: false,
    })(
      universal(import('pages/reportViewPage/ReportViewPage')),
      universal(import('pages/loginPage/LoginPage'), options)
    ),
  },
  {
    path: `${MAIN_ROUTES.ADVERTISER_REPORT.TO}/:campaignId/:reportType`,
    componentPath: 'pages/advertiserReportViewPage/AdvertiserReportViewPage',
    Component: withRestrictions({
      shouldBeLoggedIn: true,
      isAdvertiserRoute: true,
    })(
      universal(
        import('pages/advertiserReportViewPage/AdvertiserReportViewPage')
      ),
      universal(import('pages/advertiserLoginPage/LoginPage'), options)
    ),
  },
  {
    path: `${MAIN_ROUTES.INFLUENCER_DETAILS.TO}`,
    exact: true,
    componentPath: 'pages/influencerDetailsPage/InfluencerDetailsPage',
    Component: withRestrictions({
      shouldBeLoggedIn: true,
    })(
      universal(
        import('pages/influencerDetailsPage/InfluencerDetailsPage'),
        options
      ),
      universal(import('pages/loginPage/LoginPage'), options)
    ),
  },
  {
    path: `${MAIN_ROUTES.INFLUENCERS.TO}*`,
    exact: true,
    componentPath: 'pages/influencersPage/InfluencersPage',
    Component: withRestrictions({
      shouldBeLoggedIn: true,
    })(
      universal(import('pages/influencersPage/InfluencersPage'), options),
      universal(import('pages/loginPage/LoginPage'), options)
    ),
  },
  {
    path: `${MAIN_ROUTES.ADMINS.TO}`,
    exact: true,
    componentPath: 'pages/adminsPage/AdminsPage',
    Component: withRestrictions({
      shouldBeLoggedIn: true,
    })(
      universal(import('pages/adminsPage/AdminsPage'), options),
      universal(import('pages/loginPage/LoginPage'), options)
    ),
  },
  {
    path: `${MAIN_ROUTES.ADVERTISERS.TO}*`,
    componentPath: 'pages/advertisersPage/AdvertisersPage',
    exact: false,
    Component: withRestrictions({
      shouldBeLoggedIn: true,
    })(
      universal(import('pages/advertisersPage/AdvertisersPage'), options),
      universal(import('pages/loginPage/LoginPage'), options)
    ),
    routes: [
      {
        path: `${MAIN_ROUTES.ADVERTISERS.TO}/create`,
        exact: true,
        componentPath:
          'pages/advertisersPage/advertiserCreatePage/AdvertiserCreatePage',
        Component: universal(
          import(
            'pages/advertisersPage/advertiserCreatePage/AdvertiserCreatePage'
          ),
          options
        ),
      },
      {
        path: `${MAIN_ROUTES.ADVERTISERS.TO}/:advertiserId/update`,
        exact: true,
        componentPath:
          'pages/advertisersPage/advertiserUpdatePage/AdvertiserUpdatePage',
        Component: universal(
          import(
            'pages/advertisersPage/advertiserUpdatePage/AdvertiserUpdatePage'
          ),
          options
        ),
      },
    ],
  },
  {
    path: `${MAIN_ROUTES.SETTINGS.TO}`,
    exact: true,
    componentPath: 'pages/settingsPage/SettingsPage',
    Component: withRestrictions({
      shouldBeLoggedIn: true,
    })(
      universal(import('pages/settingsPage/SettingsPage'), options),
      universal(import('pages/loginPage/LoginPage'), options)
    ),
  },
  {
    path: `${MAIN_ROUTES.NOTIFICATIONS.TO}`,
    exact: true,
    componentPath: 'pages/notifcationsPage/NotificationPage',
    Component: withRestrictions({
      shouldBeLoggedIn: true,
    })(
      universal(import('pages/notifcationsPage/NotificationPage'), options),
      universal(import('pages/loginPage/LoginPage'), options)
    ),
  },
  {
    path: '/health', // for kubernetes
    exact: true,
    componentPath: 'pages/healthPage/HealthPage',
    Component: universal(import('pages/healthPage/HealthPage'), options),
  },
  {
    path: `${MAIN_ROUTES.ADVERTISER.TO}`,
    exact: true,
    componentPath: 'pages/landingPage/announcementsPage/AnnouncementsPage',
    Component: universal(
      import('pages/landingPage/announcementsPage/AnnouncementsPage'),
      options
    ),
  },
  {
    path: `${MAIN_ROUTES.FAQ.TO}`,
    exact: true,
    componentPath: 'pages/landingPage/faqPage/FaqPage',
    Component: universal(import('pages/landingPage/faqPage/FaqPage'), options),
  },
  {
    path: `${MAIN_ROUTES.CHILD_SAFETY_POLICY.TO}`,
    exact: true,
    componentPath: 'pages/childSafetyPolicyPage/ChildSafetyPolicyPage',
    Component: universal(
      import('pages/childSafetyPolicyPage/ChildSafetyPolicyPage'),
      options
    ),
  },
  {
    path: `${MAIN_ROUTES.PRIVACY_POLICY.TO}`,
    exact: true,
    componentPath: 'pages/privacyPolicyPage/PrivacyPolicyPage',
    Component: universal(
      import('pages/privacyPolicyPage/PrivacyPolicyPage'),
      options
    ),
  },
  {
    path: '*',
    componentPath: 'pages/notFoundPage/NotFoundPage',
    Component: universal(import('pages/notFoundPage/NotFoundPage'), options),
    status: 404,
  },
];
